export enum WorkflowStageEnum {
  SID_APP_INIT_NEW='SID_APP_INIT_NEW',
  SID_APP_INIT_RENEW='SID_APP_INIT_RENEW',
  SID_APP_INIT_DUPLICATE='SID_APP_INIT_DUPLICATE',

  SID_NEW_PAYMENT_COM='SID_NEW_PAYMENT_COM',
  SID_RENEW_PAYMENT_COM='SID_RENEW_PAYMENT_COM',
  SID_DUP_PAYMENT_COM='SID_RENEW_PAYMENT_COM',

  SID_N_REJECT='SID_N_REJECT',
  SID_R_REJECT='SID_R_REJECT',
  SID_D_REJECT='SID_D_REJECT',

  SID_N_VERIFICATION_APP='SID_N_VERIFICATION_APP',
  SID_R_VERIFICATION_APP='SID_R_VERIFICATION_APP',
  SID_D_VERIFICATION_APP='SID_D_VERIFICATION_APP',

  SID_EXM_APP_NEW='SID_EXM_APP_NEW',
  SID_EXM_APP_RENEW='SID_EXM_APP_RENEW',
  SID_EXM_APP_DUPLICATE='SID_EXM_APP_DUPLICATE',

  SID_EXM_RET_NEW='SID_EXM_RET_NEW',
  SID_EXM_RET_RENEW='SID_EXM_RET_RENEW',
  SID_EXM_RET_DUPLICATE='SID_EXM_RET_DUPLICATE',

  SID_SHO_APP_NEW='SID_SHO_APP_NEW',
  SID_SHO_APP_RENEW='SID_SHO_APP_RENEW',
  SID_SHO_APP_DUPLICATE='SID_SHO_APP_DUPLICATE',

  SID_SHO_RET_NEW='SID_SHO_RET_NEW',
  SID_SHO_RET_RENEW='SID_SHO_RET_RENEW',
  SID_SHO_RET_DUPLICATE='SID_SHO_APP_DUPLICATE',

  SID_EXM_FWD_DG_NEW='SID_EXM_FWD_DG_NEW',
  SID_EXM_FWD_DG_RENEW='SID_EXM_FWD_DG_RENEW',
  SID_EXM_FWD_DG_DUPLICATE='SID_EXM_FWD_DG_DUPLICATE',

  SID_EXM_BLK_PEND = 'SID_EXM_BLK_PEND',
  SID_EXM_BLK_REJ = 'SID_EXM_BLK_REJ',
  SID_DG_BLK_REJ = 'SID_DG_BLK_REJ',
  SID_EXM_BLK_PEND_AUTH = 'SID_EXM_BLK_PEND_AUTH',
  SID_DG_BLK_APR = 'SID_DG_BLK_APR',

  SID_EXM_REV_BLK_PEND = 'SID_EXM_REV_BLK_PEND',
  SID_EXM_REV_BLK_REJ = 'SID_EXM_REV_BLK_REJ',
  SID_DG_REV_BLK_REJ = 'SID_DG_REV_BLK_REJ',
  SID_DG_REV_BLK_PEND_AUTH = 'SID_DG_REV_BLK_PEND_AUTH',
  SID_DG_REV_BLK_APR = 'SID_DG_REV_BLK_APR',

  SID_DG_SUS_PEND_AUTH = 'SID_DG_SUS_PEND_AUTH',
  SID_EXM_SUS_REJ = 'SID_EXM_SUS_REJ',
  SID_DG_SUS_REJ = 'SID_DG_SUS_REJ',
  SID_EXM_SUS_PEND_AUTH = 'SID_EXM_SUS_PEND_AUTH',
  SID_DG_SUS_APR = 'SID_DG_SUS_APR',

  SID_EXM_REV_SUS_PEND = 'SID_EXM_REV_SUS_PEND',
  SID_EXM_REV_SUS_REJ = 'SID_EXM_REV_SUS_REJ',
  SID_DG_REV_SUS_REJ = 'SID_DG_REV_SUS_REJ',
  SID_DG_REV_SUS_PEND_AUTH = 'SID_DG_REV_SUS_PEND_AUTH',
  SID_DG_REV_SUS_APR = 'SID_DG_REV_SUS_APR',

  SID_DISPATCH_COM_NEW = 'SID_DISPATCH_COM_NEW',

  APPLICATION_APPROVED = "SID_APP_COMPLETED_NEW",
  PRINT_SUCCESSFULL = "SID_PRNT_SCSS",
  SID_QA_VERIFIED = "SID_QA_COM_NEW",

}
